import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from 'hooks/useAuth';
import AccountLogo from 'components/Account-Logo';
import ButtonDownloadCSV from '../Button-Download-CSV';
import ButtonAddKeyword from '../Button-Add-Keyword';
import ButtonFilter from '../Button-Filter';
import FilterKeywordMonitoring from '../Filter-Keyword-Monitoring';
import { HeaderKeywordMonitoringStyled } from './styles';

const HeaderKeywordMonitoring = ({
  groups,
  tags,
  chartData,
  toggleModal,
  fetchPerformanceData,
  setFilters,
  isLoading,
}) => {
  const { user } = useAuth();
  const accountId = user?.account;
  const isAdminStatus = ['Super Admin', 'Admin'].includes(user.adminStatus);
  const [filterOpen, setFilterOpen] = useState(false);

  const toggle = () => setFilterOpen((prevState) => !prevState);

  return (
    <HeaderKeywordMonitoringStyled>
      <div className="container-full">
        <div className="task-summary-wrapper m-0 justify-content-between align-items-center">
          <div className="task-summary-photo m-0 p-0 d-flex align-items-center">
            <AccountLogo accountId={accountId} />
          </div>
          <div className="d-flex w-100 justify-content-end align-items-center gap-3 h-100">
            <ButtonDownloadCSV chartData={chartData} disabled={isLoading} />
            <ButtonFilter onClickFunction={toggle} disabled={isLoading} />
            {isAdminStatus && (
              <ButtonAddKeyword onClickFunction={toggleModal} disabled={isLoading} />
            )}
          </div>
        </div>
        {filterOpen && (
          <FilterKeywordMonitoring
            groups={groups}
            tags={tags}
            fetchPerformanceData={fetchPerformanceData}
            setFilters={setFilters}
          />
        )}
      </div>
    </HeaderKeywordMonitoringStyled>
  );
};

HeaderKeywordMonitoring.propTypes = {
  groups: PropTypes.array,
  tags: PropTypes.array,
  chartData: PropTypes.array,
  toggleModal: PropTypes.func,
  fetchPerformanceData: PropTypes.func,
  setFilters: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default HeaderKeywordMonitoring;
